const CATALOGUE_URL = '/api/catalogue/esim';

let cataloguePromise;

export function loadPublicEsimCatalogue(fetchImpl = fetch) {
  if (!cataloguePromise) {
    cataloguePromise = fetchImpl(CATALOGUE_URL, { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error('eSIM catalogue unavailable');
        return response.json();
      })
      .then((catalogue) => {
        if (!catalogue || !Array.isArray(catalogue.countries)) throw new Error('Invalid eSIM catalogue');
        return catalogue;
      })
      .catch((error) => {
        cataloguePromise = undefined;
        throw error;
      });
  }
  return cataloguePromise;
}

export function countriesForFamily(catalogue, family) {
  if (!catalogue?.countries) return [];
  return catalogue.countries
    .filter((country) => country.products?.some((product) => product.family === family))
    .map((country) => ({ value: country.name, label: country.name, code: country.code }));
}

export function productIsAvailable(catalogue, family, countryCode, data, durationDays) {
  const dataAmountMb = Number.parseInt(String(data), 10) * 1000;
  return Boolean(catalogue?.countries
    ?.find((country) => country.code === countryCode)
    ?.products?.some((product) => product.family === family
      && product.dataAmountMb === dataAmountMb
      && product.durationDays === durationDays));
}

export function resetPublicEsimCatalogueForTests() {
  cataloguePromise = undefined;
}
